import React, { useState, useEffect } from "react";
import axios from "axios";
import API from "@/api";
import Markdown from "@sui/chat-ui/es/ChatUI/components/markdown";
import { Button, Empty, Spin, Tabs } from "antd";
import "./index.less";
import Realsql from "./realsql";
import Viewsql from "./viewsql";
import Sqljx from "./sqljx";

function QsSqlData(props) {
  const { data: dData } = props;
  const [data, setData] = useState("");
  const [viewData, setViewData] = useState("");
  const [realData, setRealData] = useState("");
  const [jxData, setJxData] = useState("");
  const [spinning, setSpinning] = useState(true);
  const [tab, setTab] = useState("viewSql");
  useEffect(() => {
    axios
      .post(API.getQsSqlData, {
        question_id: dData?.data?.data?.qId,
      })
      .then((res) => {
        console.log(res);
        setData(res?.data?.executed_sql_markdown);
        setViewData(res?.data?.view_sql_markdown);
        setRealData(res?.data?.real_sql_markdown);
      });
  }, []);

  const handleStreamRequest = async () => {
    const url = API.getJxQsSqlData;
    const payload = {
      question_id: dData?.data?.data?.qId,
    };

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          // 如果需要鉴权
          // 'Authorization': 'Bearer token'
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) throw new Error("Network response was not ok");
      setSpinning(false);
      // 1. 获取读取器
      const reader = response.body.getReader();
      const decoder = new TextDecoder("utf-8");
      let resultText = "";

      // 2. 循环读取流
      while (true) {
        const { done, value } = await reader.read();
        if (done) break; // 读取完毕

        // 3. 解码二进制数据
        const chunk = decoder.decode(value, { stream: true });
        // chunk 可能是多行数据，需要按换行符分割
        const lines = chunk.split("\n");

        lines.forEach((line) => {
          if (line.trim().startsWith("data:")) {
            // 去掉 'data:' 前缀
            const jsonString = line.replace(/^data:/, "").trim();
            if (jsonString === "[DONE]") return; // 结束标志

            try {
              const json = JSON.parse(jsonString);
              // 4. 提取增量内容 (delta) 并追加到结果中
              if (json.data && json.data.delta) {
                resultText += json.data.delta;
                // 更新页面显示 (例如 React 的 setState)
                setJxData(resultText);
              }
            } catch (e) {
              console.error("解析 JSON 失败:", e);
            }
          }
        });
      }
    } catch (error) {
      console.error("请求失败:", error);
    }
  };
  return (
    <div className="qssql">
      <Tabs
        items={[
          {
            key: "viewSql",
            label: "逻辑SQL",
            children: tab === "viewSql"  ?  <Viewsql viewData={viewData} />  :undefined,
          },
          {
            key: "realSql",
            label: "物理SQL",
            children:  tab === "realSql"?<Realsql realData={realData} /> :undefined,
          },
          {
            key: "sqljx",
            label: "SQL解析",
            children: tab === "sqljx"?<Sqljx data={data} question_id={dData?.data?.data?.qId}  /> :undefined,
          },
        ]}
        type="card"
        activeKey={tab}
        onChange={(activeKey) => {
          setTab(activeKey);
        }}
      />
      {/* <div className="sql">
        <div className="title">取数Sql</div>
        <div className="content">
          <Markdown
            data={{
              think: null,
              thinking: false,
              content: data,
            }}
          ></Markdown>
        </div>
      </div> */}
      {/* <div className="action">
        <Button
          type="primary"
          onClick={() => {
            handleStreamRequest();
          }}
        >
          SQL解析
        </Button>
      </div> */}
      {/* <div className="sqlContent">
        {spinning ? (
          <Empty description="暂无数据" />
        ) : (
          <Spin spinning={spinning}>
            <div className="jxContent">
              <Markdown
                data={{
                  think: null,
                  thinking: false,
                  content: jxData,
                }}
              ></Markdown>
            </div>
          </Spin>
        )}
      </div> */}
    </div>
  );
}

export default QsSqlData;
